import styles from "./styles.module.scss";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import React from "react";


export const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const { carouselState: { currentSlide, slidesToShow }, routes, dotsRefs } = rest;
    const showButtons = routes.length > slidesToShow

    return (
        <div className={styles.customButtomGroup}>
            {showButtons && <div className={styles.buttomGroup}>
                <button className={`${styles.arrow} ${currentSlide === 0 ? styles.disabled : ''}`} onClick={() => previous()} ><FaArrowLeft /></button>
                <div className={styles.dots}>
                    {Array.from({ length: Math.ceil(routes.length / slidesToShow) }).map((_, i) => (
                        <span className={styles.ocultDot} onClick={() => dotsRefs(i)} ></span>
                    ))}
                </div>
                <button onClick={() => next()} className={styles.arrow}> <FaArrowRight /> </button>
            </div>}
        </div>
    );
};